import PropTypes from 'prop-types'
import SectionCard from '../shared/SectionCard'
import { Button } from 'baseui/button'
import useDevTools from '@/containers/DevToolsNew/shared/useDevTools'

import ContactsRow from './table/ContactsRow'
import TableLoadingOverlay from './table/TableLoadingOverlay'

import {
  TableWrap,
  Table,
  TheadRow,
  Th,
  Td,
  FooterRow,
  MutedText,
  FooterActions, ThSubLabel
} from './table/styled-components'

const ContactsTable = ({ rows, isLoading, error, footer, pagination }) => {
  const { t } = useDevTools()

  const safeRows = Array.isArray(rows) ? rows : []
  const safeFooter = footer || { from: 0, to: 0, total: 0 }
  const safePagination = pagination || {
    canGoPrevious: false,
    canGoNext: false,
    goPreviousPage: () => {},
    goNextPage: () => {},
  }

  const showInitialLoader = isLoading && safeRows.length === 0
  const showOverlayLoader = isLoading && safeRows.length > 0

  const canRenderContent = !showInitialLoader
  const hasError = canRenderContent && Boolean(error)
  const isEmpty = canRenderContent && !error && safeRows.length === 0
  const hasRows = canRenderContent && !error && safeRows.length > 0


  return (
    <SectionCard>
      <TableWrap>
        {showOverlayLoader && (
          <TableLoadingOverlay text={t('contacts.loading')} />
        )}

        <Table>
          <thead>
          <TheadRow>
            <Th>
              <div>{t('contacts.table.contact_id')}</div>
              <ThSubLabel>{t('contacts.table.contract_id')}</ThSubLabel>
            </Th>
            <Th>{t('contacts.table.contact')}</Th>
            <Th>{t('contacts.table.contract_type')}</Th>
            <Th>{t('contacts.table.prestation_type')}</Th>
            <Th>{t('contacts.table.status')}</Th>
            <Th>{t('contacts.table.created_at')}</Th>
            <Th>{t('contacts.table.updated_at')}</Th>
            <Th>{t('contacts.table.actions')}</Th>
          </TheadRow>
          </thead>

          <tbody>
          {showInitialLoader && (
            <tr>
              <Td colSpan={8}>{t('contacts.loading')}</Td>
            </tr>
          )}

          {hasError && (
            <tr>
              <Td colSpan={8}>{String(error)}</Td>
            </tr>
          )}

          {isEmpty && (
            <tr>
              <Td colSpan={8}>{t('contacts.no_results')}</Td>
            </tr>
          )}

          {hasRows &&
            safeRows.map(row => (
              <ContactsRow
                key={row.rowKey}
                row={row}
                t={t}
              />
            ))}
          </tbody>

        </Table>
      </TableWrap>

      <FooterRow>
        <MutedText>
          {t('common.showing', {
            from: safeFooter.from,
            to: safeFooter.to,
            total: safeFooter.total,
          })}
        </MutedText>

        <FooterActions>
          <Button
            size="compact"
            kind="secondary"
            disabled={!safePagination.canGoPrevious || isLoading}
            onClick={safePagination.goPreviousPage}
          >
            {t('common.previous')}
          </Button>

          <Button
            size="compact"
            kind="secondary"
            disabled={!safePagination.canGoNext || isLoading}
            onClick={safePagination.goNextPage}
          >
            {t('common.next')}
          </Button>
        </FooterActions>
      </FooterRow>
    </SectionCard>
  )
}

ContactsTable.propTypes = {
  rows: PropTypes.array,
  isLoading: PropTypes.bool,
  error: PropTypes.any,
  footer: PropTypes.shape({
    from: PropTypes.number,
    to: PropTypes.number,
    total: PropTypes.number,
  }),
  pagination: PropTypes.shape({
    canGoPrevious: PropTypes.bool,
    canGoNext: PropTypes.bool,
    goPreviousPage: PropTypes.func,
    goNextPage: PropTypes.func,
  }),
}

export default ContactsTable
